
import { Component, Vue, Prop } from "vue-property-decorator";
import { ExamVersionInfo } from "@/lib/model/exambuilder/exam-component/exam";
import IntroduceCard from "../components/introduce-card.vue";
import HinaRadioGroup from "../baseComponent/hina-radio-group.vue";
import HinaTextarea from "../baseComponent/hina-textarea.vue";
import HinaUpload from "../baseComponent/hina-upload.vue";
import HinaSwitch from "../baseComponent/hina-switch.vue";
import HinaInput from "../baseComponent/hina-input.vue";
import {
  Publicity,
  DescBefore,
  DescAfter,
  LocationConfig
} from "@/lib/model/exambuilder/exam-component/component";
import Pop from "../components/blue-pop.vue";
import TtsConfigPop from "../components/tts-config-pop.vue";
import HinaCheckboxGroup from "../baseComponent/hina-checkbox-group.vue";
import HinaCheckbox from "../baseComponent/hina-checkbox.vue";
import { ElForm } from "element-ui/types/form";
import Editor5 from "@/components/editor/classic-editor5.vue";
import TencentMap from "../components/t-map.vue";
import request from "@/lib/request/request";

@Component({
  components: {
    Editor5,
    HinaCheckbox,
    HinaCheckboxGroup,
    Pop,
    TtsConfigPop,
    HinaSwitch,
    HinaUpload,
    HinaInput,
    HinaTextarea,
    HinaRadioGroup,
    IntroduceCard,
    TencentMap
  }
})
export default class DescBeforeCom extends Vue {
  @Prop() formItemData!: ExamVersionInfo; // 组件数据

  // 宣传页
  get publicityPageConfig() {
    return this.formItemData.publicityPageConfig.configData;
  }

  get defaultPublicityContent() {
    return new Publicity().publicityPageContent;
  }

  get vrGuideConfig() {
    return this.formItemData.vrGuideConfig;
  }

  get workLocation() {
    return this.formItemData.workLocationConfig;
  }

  get mapPosition() {
    return [
      {
        latitude: this.position.latitude,
        longitude: this.position.longitude
      }
    ];
  }

  position = {
    address: "",
    detailAddress: "",
    latitude: 39.908803,
    longitude: 116.397464,
    hasVerify: false
  };

  // 封面
  publicityPageCoverTypeOptions = [
    { name: "默认封面", value: 1 },
    { name: "自定义封面", value: 2 }
  ];
  publicityPageCoverType = 1;

  handleChangePublicityPageCoverType(v: number) {
    if (v === 1) {
      this.publicityPageConfig.publicityPageVideoCoverUrl =
        "https://oss.hina.com/app/hina/2021/07/10/3f1396a2ddd6a8493c582f22c69dae39.png";
    } else {
      this.publicityPageConfig.publicityPageVideoCoverUrl = "";
    }

    this.handleChange();
  }

  // 视频
  publicityPageVideoTypeOptions = [
    { name: "不使用", value: 0 },
    { name: "默认视频", value: 1 },
    { name: "自定义视频", value: 2 }
  ];

  handleChangePublicityPageVideoType(v: number) {
    if (v === 1) {
      this.publicityPageConfig.publicityPageVideoUrl =
        "https://vod.hina.com/a3309d04251940faa56806be59bdf122/8c7be05066f64d29ae74ffbd5500daa9-ca173c7e0f3241eb8285dedda051a1ba-ld.mp4";
    } else if (v === 2) {
      this.publicityPageConfig.publicityPageVideoUrl = "";
    } else {
      this.publicityPageConfig.publicityPageVideoUrl = "";
    }

    this.handleChange();
  }

  resetPublicityContent() {
    this.publicityPageConfig.publicityPageContent = this.defaultPublicityContent;
    this.handleChange();
  }

  // 须知页
  get descBefore() {
    return this.formItemData.descBefore.configData;
  }

  get defaultDescBeforeContent() {
    return new DescBefore().descBefore;
  }

  descBeforeShowWayOptions = [
    { name: "AI面试官朗读", value: 0 },
    { name: "默认背景", value: 1 },
    { name: "自定义背景", value: 2 }
  ];

  handleChangeDescBeforeShowWay(v: number) {
    if (v === 0) {
      this.descBefore.descBeforeShowWayImgUrl = "";
    }
    if (v === 1) {
      this.descBefore.descBeforeShowWayImgUrl =
        "https://oss.hina.com/app/hina/2021/07/10/3f1396a2ddd6a8493c582f22c69dae39.png";
    }
    if (v === 2) {
      this.descBefore.descBeforeShowWayImgUrl = "";
    }

    this.handleChange();

    if (this.descAfter.descAfterShowWayIsSame === 1) {
      this.setSame();
    }
  }

  handleUploadDescBeforeImg() {
    if (this.descAfter.descAfterShowWayIsSame === 1) {
      this.setSame();
    }

    this.handleChange();
  }

  resetDescBeforeContent() {
    this.descBefore.descBefore = this.defaultDescBeforeContent;
    this.handleChange();
  }

  handleAddPosition() {
    this.formItemData.workLocationConfig.configData.locationList.push(
      new LocationConfig().assign(this.position)
    );
    (this.$refs.formRef as any).clearValidate(
      "workLocation.configData.locationList"
    );
    this.position = {
      address: "",
      detailAddress: "",
      latitude: 39.908803,
      longitude: 116.397464,
      hasVerify: false
    };
  }

  // 结束页
  get descAfter() {
    return this.formItemData.descAfter.configData;
  }

  get defaultDescAfterContent() {
    return new DescAfter().descAfter;
  }

  descAfterShowWayOptions = [
    { name: "AI面试官朗读", value: 0 },
    { name: "默认背景", value: 1 },
    { name: "自定义背景", value: 2 }
  ];

  handleChangeDescAfterShowWay(v: number) {
    if (v === 0) {
      this.descAfter.descAfterShowWayImgUrl = "";
    }
    if (v === 1) {
      this.descAfter.descAfterShowWayImgUrl =
        "https://oss.hina.com/app/hina/2021/07/10/3f1396a2ddd6a8493c582f22c69dae39.png";
    }
    if (v === 2) {
      this.descAfter.descAfterShowWayImgUrl = "";
    }

    this.handleChange();
  }

  setSame() {
    this.descAfter.descAfterShowWay = this.descBefore.descBeforeShowWay;
    this.descAfter.descAfterShowWayImgUrl = this.descBefore.descBeforeShowWayImgUrl;
  }

  handleChangeSame(value: number) {
    if (value === 1) {
      this.setSame();
    } else {
      this.descAfter.descAfterShowWayImgUrl = "";
    }

    this.handleChange();
  }

  resetDescAfterContent() {
    this.descAfter.descAfter = this.defaultDescAfterContent;
    this.handleChange();
  }

  // 校验数据
  get formData() {
    return {
      publicityPageConfig: this.publicityPageConfig,
      descBefore: this.descBefore,
      descAfter: this.descAfter,
      vrGuideConfig: this.vrGuideConfig,
      workLocation: this.workLocation
    };
  }

  handleChange(field?: string) {
    if (field) {
      (this.$refs.formRef as any).validateField(field);
    }
    this.$emit("setBar", false);
  }

  get rules() {
    return {
      "publicityPageConfig.publicityPageContent": [
        {
          required: true,
          message: "请输入展示文案",
          trigger: ["change", "blur"]
        }
      ],
      "publicityPageConfig.publicityPageVideoCoverUrl": [
        {
          required:
            this.publicityPageConfig.publicityPageVideoCoverUseWhich === 2,
          message: "请上传自定义封面",
          trigger: "blur"
        }
      ],
      "publicityPageConfig.publicityPageVideoUrl": [
        {
          required: this.publicityPageConfig.publicityPageVideoUseWhich === 2,
          message: "请上传自定义视频",
          trigger: "blur"
        }
      ],
      "descBefore.descBefore": [
        {
          required: true,
          message: "请输入展示文案",
          trigger: ["change", "blur"]
        }
      ],
      "descBefore.descBeforeShowWayImgUrl": [
        {
          required: this.descBefore.descBeforeShowWay === 2,
          message: "请上传自定义背景",
          trigger: "blur"
        }
      ],
      "descAfter.descAfter": [
        {
          required: true,
          message: "请输入展示文案",
          trigger: ["change", "blur"]
        }
      ],
      "descAfter.descAfterShowWayImgUrl": [
        {
          required:
            this.descAfter.descAfterShowWay === 2 &&
            this.descAfter.descAfterShowWayIsSame !== 1,
          message: "请上传自定义背景",
          trigger: "blur"
        }
      ],
      "vrGuideConfig.configData.vrUrl": [
        {
          required: this.vrGuideConfig.use === 1,
          message: "请输入vr视频链接",
          trigger: "blur"
        }
      ],
      "workLocation.configData.locationList": [
        {
          type: "array",
          required: this.workLocation.use === 1,
          message: "请至少添加一个地址",
          trigger: "validator"
        }
      ]
    };
  }

  formItemCheck() {
    this.publicityPageConfig.publicityPageContent = this.publicityPageConfig.publicityPageContent.trim();
    this.descBefore.descBefore = this.descBefore.descBefore.trim();
    this.descAfter.descAfter = this.descAfter.descAfter.trim();
    return new Promise(resolve => {
      (this.$refs.formRef as ElForm)
        .validate()
        .then(() => {
          if (
            this.workLocation.use === 1 &&
            !this.workLocation.configData.locationList.length
          ) {
            console.log(123123);
            resolve("descConfig");
            return;
          }
          resolve("");
        })
        .catch(() => resolve("descConfig"));
    });
  }

  async verifyAddress() {
    if (!this.position.address) {
      this.$message.warning("请输入对外展示名称");
      return;
    }
    if (!this.position.detailAddress) {
      this.$message.warning("请输入详细地址");
      return;
    }
    const res = await request.postInterviewApi("public/common/mapRedirect", {
      path: "/ws/geocoder/v1",
      req: {
        address: this.position.detailAddress
      }
    });
    if (res.data.code === 0) {
      if (
        this.workLocation.configData.locationList.find(item => {
          return (
            item.latitude === res.data.data.location.lat &&
            item.longitude === res.data.data.location.lng
          );
        })
      ) {
        this.$message.warning("存在位置相同的地址");
        return;
      }
      this.position = {
        address: this.position.address,
        detailAddress: this.position.detailAddress,
        latitude: res.data.data.location.lat,
        longitude: res.data.data.location.lng,
        hasVerify: true
      };
      (this.$refs.map as any).setCenter(
        this.position.latitude,
        this.position.longitude
      );
    }
  }
}
